if (!Object.prototype.foreach) {
    Object.defineProperty(Object.prototype, 'foreach', {
        value: function (callback) {
            for (let key in this) {
                if (!Object.hasOwnProperty.call(this, key)) continue;
                callback(this[key], key);
            }
        },
        enumerable: false
    });
}